import React from "react";
import { useI18n } from "../i18n/I18nContext";

export default function CookiePolicy() {
  const { t, raw } = useI18n();
  const headers = raw("pages.cookies_page.table_headers") || {};
  const rows = raw("pages.cookies_page.table_rows") || [];

  const openPrefs = () => {
    window.dispatchEvent(new Event("dervaniq:open-cookie-preferences"));
  };

  return (
    <main data-testid="cookie-policy-page" className="bg-white">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-10 lg:py-24">
        <h1
          className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl"
          style={{ fontFamily: "'Cabinet Grotesk', 'IBM Plex Sans', sans-serif" }}
        >
          {t("pages.cookies_page.title")}
        </h1>
        <p className="mt-2 text-sm font-medium uppercase tracking-widest text-slate-500">
          {t("pages.cookies_page.updated")}
        </p>
        <p className="mt-6 text-base leading-relaxed text-slate-700">
          {t("pages.cookies_page.intro")}
        </p>

        <h2 className="mt-12 text-xl font-semibold text-slate-900">
          {t("pages.cookies_page.table_title")}
        </h2>
        <div className="mt-4 overflow-x-auto rounded-xl border border-slate-200">
          <table className="min-w-full divide-y divide-slate-200 text-left text-sm">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-4 py-3 font-semibold text-slate-700">{headers.name}</th>
                <th className="px-4 py-3 font-semibold text-slate-700">{headers.provider}</th>
                <th className="px-4 py-3 font-semibold text-slate-700">{headers.purpose}</th>
                <th className="px-4 py-3 font-semibold text-slate-700">{headers.duration}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {rows.map((r, i) => (
                <tr key={i}>
                  <td className="px-4 py-3 font-mono text-xs text-slate-800">{r.name}</td>
                  <td className="px-4 py-3 text-slate-700">{r.provider}</td>
                  <td className="px-4 py-3 text-slate-700">{r.purpose}</td>
                  <td className="px-4 py-3 text-slate-700">{r.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h2 className="mt-12 text-xl font-semibold text-slate-900">
          {t("pages.cookies_page.manage_title")}
        </h2>
        <p className="mt-2 text-base leading-relaxed text-slate-700">
          {t("pages.cookies_page.manage_body")}
        </p>
        <button
          type="button"
          onClick={openPrefs}
          data-testid="cookies-page-manage-button"
          className="mt-4 inline-flex items-center gap-2 rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800"
        >
          {t("pages.cookies_page.manage_button")}
        </button>

        <h2 className="mt-12 text-xl font-semibold text-slate-900">
          {t("pages.cookies_page.browser_title")}
        </h2>
        <p className="mt-2 text-base leading-relaxed text-slate-700">
          {t("pages.cookies_page.browser_body")}
        </p>
      </div>
    </main>
  );
}
